import React from "react";

const Careers = () => {
  return (
    <section className="py-20 bg-white text-center">
      {/* Heading */}
      <h2 className="text-5xl font-extrabold text-gray-300 mb-6 tracking-wide">
        CAREERS
      </h2>

      {/* Subheading */}
      <h3 className="text-2xl font-semibold mb-6">
        Achievements
        <span className="text-red-500 italic font-bold">
          & Trusted Partnerships,
        </span>
      </h3>

      {/* Description */}
      <p className="max-w-3xl mx-auto text-gray-600 text-lg leading-relaxed mb-6">
        Partnered with The International Institute for Justice and Rule of Law –
        Supported terrorism-related case handling in the criminal justice
        system.
      </p>

      <p className="max-w-2xl mx-auto text-gray-600 text-lg leading-relaxed">
        Represented over 950 domestic and international clients across civil,
        criminal, and commercial matters.
      </p>

      {/* Button */}
      <div className="mt-10">
        <a
          href="/appointment"
          className="px-6 py-3 bg-[#C9A227] text-white font-semibold rounded-md shadow hover:bg-[#755042] transition"
        >
          Book Consultation
        </a>
      </div>
    </section>
  );
};

export default Careers;
